<div class="wrapper">
  <app-day-forecast
    *ngFor="let day of forecast"
    [forecast]="day"
  ></app-day-forecast>
</div>
